import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "tw_img w-64" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "m-4" }
const _hoisted_8 = { class: "tw_h2 mb-2" }
const _hoisted_9 = { key: 0 }

import * as Vue from "vue";
import DetailButton from "@/components/DetailButton.vue";
import im2 from "@/components/Img2.vue";
// import { Icon } from "@iconify/vue";
import * as Helper from "@/helper";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useHead } from "@vueuse/head";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

/* eslint-disable */
// src\views\HomeView.vue
const router = useRouter();

// head - canonical 설정
const route = useRoute();
useHead({
  title: `SIDNFT | apps`,
  link: [
    {
      rel: "canonical",
      href: Vue.computed(() => {
        return Helper.canon_head + route.path;
      }),
    },
  ],
});

//
let uid_v = 1;
const app_list = [
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-04-22",
    icon: "/jcat/app_icon_512.webp",
    title: "jigsaw puzzles - brain games",
    desc: "Puzzle game with animals, scenery, and videos",
    to: "/jcat",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-01-01",
    icon: "/eb/easy_1_icon_v2.png",
    title: "122 Easy",
    desc: "Click on the square to increase the number.",
    to: "/eb",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-02-01",
    icon: "/af/app_icon.png",
    title: "Add Force 1",
    desc: "a messy physical-based defense game",
    to: "/af",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-04-24",
    icon: "/ba/ba_16_gif.webp",
    title: "Tab to Dismantle",
    desc: "Look at the direction of the arrow and tap to separate it",
    to: "/ba",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-09-07",
    icon: "/rpg2026/rpg2026_icon_01.webp",
    title: "RPG GAME",
    desc: "I plan to produce it steadily and over the long term from the beginning.",
    to: "/rpg2026",
  },
  // TECH DEMO SECTION
  {
    uid: uid_v++,
    step: 1,
    date: "2025-12-01",
    section: "DEMO PROJECT",
  },
  // TECH DEMO APPS
  {
    uid: uid_v++,
    step: 2,
    date_mod: "2025-12-01",
    icon: "/mp/sr_app_icon.jpg",
    title: "SID-ROOM",
    desc: "The game is wildly themed with APTOS coins, NFTs, WEB3, and MMORPGs.",
    to: "https://room.sidnft.com",
  },
];

const page = Vue.ref({
  item_list: [] as any[],
});

Vue.onMounted(() => {
  app_list.sort((a, b) => {
    // 스텝 낮은게 위로
    if (a.step < b.step) return -1;
    if (a.step > b.step) return 1;

    // 최근게 위로
    if (a.date_mod > b.date_mod) return -1;
    if (a.date_mod < b.date_mod) return 1;

    return 0;
  });

  page.value.item_list = app_list;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).item_list, (data) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mb-16 md:flex",
        key: data.uid
      }, [
        (data.section)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", null, _toDisplayString(data.section), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (data.to !== undefined)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_unref(router).push(data.to))
                    }, [
                      _createVNode(im2, {
                        src: data.icon
                      }, null, 8, ["src"])
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (data.link !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("a", {
                        href: data.link,
                        target: "_blank"
                      }, [
                        _createVNode(im2, {
                          src: data.icon
                        }, null, 8, ["src"])
                      ], 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(data.title), 1),
          _createElementVNode("div", null, _toDisplayString(data.desc), 1),
          (data.to)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(DetailButton, {
                  to: data.to
                }, null, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})